<template>
  <v-container class="mt-4 ml-2" fluid>

    <v-row>
      <v-col cols="12">

        <v-card class="shadowCard">

          <!-- ================= HEADER ================= -->
          <v-card-title class="pb-2">
            <!-- Primera fila: título -->
            <div class="d-flex align-center justify-space-between mb-3" style="width: 100%;">
              <span class="text-subtitle-1 font-weight-bold">
                Administración Vacaciones Empleados
              </span>

              <div class="d-flex align-center">
                <v-btn
                  color="green"
                  dark
                  small
                  tile
                  class="mr-2"
                  :disabled="!vacacionesFiltradas.length"
                  @click="exportarVacacionesExcel"
                >
                  <v-icon left small>mdi-microsoft-excel</v-icon>
                  Excel
                </v-btn>
                <v-btn color="primary" dark small rounded @click="initialize()" class="mr-2">Actualizar</v-btn>
              </div>
            </div>

            <!-- Segunda fila: Buscador y filtros -->
            <v-row dense class="ma-0" style="width: 100%;">
              <v-col cols="12" sm="6" md="3" class="py-1">
                <v-text-field
                  v-model="search"
                  label="Buscar"
                  prepend-inner-icon="mdi-magnify"
                  dense
                  hide-details
                  outlined
                  filled
                  clearable
                />
              </v-col>

              <v-col cols="12" sm="6" md="2" class="py-1">
                <v-select
                  v-model="filtroEstatus"
                  :items="estatusFiltroItems"
                  label="Filtrar por estatus"
                  dense
                  hide-details
                  outlined
                  filled
                  clearable
                />
              </v-col>

              <v-col cols="12" sm="6" md="3" class="py-1">
                <v-autocomplete
                  v-model="filtroPersona"
                  :items="personasFiltroItems"
                  item-text="text"
                  item-value="value"
                  label="Filtrar por persona"
                  dense
                  hide-details
                  outlined
                  filled
                  clearable
                />
              </v-col>

              <v-col cols="6" sm="3" md="2" class="py-1">
                <v-text-field
                  v-model="filtroFechaInicio"
                  label="Desde"
                  type="date"
                  dense
                  hide-details
                  outlined
                  filled
                  clearable
                />
              </v-col>

              <v-col cols="6" sm="3" md="2" class="py-1">
                <v-text-field
                  v-model="filtroFechaFin"
                  label="Hasta"
                  type="date"
                  dense
                  hide-details
                  outlined
                  filled
                  clearable
                />
              </v-col>
            </v-row>
          </v-card-title>


          <!-- ================= TABLA ================= -->
          <v-data-table
            :headers="headers"
            :items="vacacionesFiltradas"
            :search="search"
            item-key="idvacaciones"
            show-expand
            single-expand
            :expanded.sync="expanded"
            dense
            elevation-0
          >

            <!-- JEFE -->
            <template v-slot:item.respuesta_jefe="{ item }">
              <v-chip
                small
                dark
                class="pointer"
                :color="colorEstatus(item.respuesta_jefe)"
                @click="abrirRespuesta(item,'jefe')"
              >
                {{ textoEstatus(item.respuesta_jefe) }}
              </v-chip>
            </template>

            <!-- RH -->
            <template v-slot:item.respuesta_rh="{ item }">
              <v-chip
                small
                dark
                class="pointer"
                :color="colorEstatus(item.respuesta_rh)"
                @click="abrirRespuesta(item,'rh')"
              >
                {{ textoEstatus(item.respuesta_rh) }}
              </v-chip>
            </template>

            <template v-slot:item.prima_vacaciones="{ item }">
              {{ formatMoney(item.prima_vacaciones) }}
            </template>

            <template v-slot:item.fecha_inicio="{ item }">
              {{ fechaSolo(item.fecha_inicio) }}
            </template>

            <template v-slot:item.fecha_fin="{ item }">
              {{ fechaSolo(item.fecha_fin) }}
            </template>

            <!-- ACCIONES -->
            <template v-slot:item.actions="{ item }">
              <v-btn
                v-if="puedeEditarItem(item)"
                x-small color="primary" class="mr-1" @click="editItem(item)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>

              <v-btn
                v-if="puedeEliminarItem(item)"
                x-small
                color="error"
                @click="deleteItem(item)"
              >
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>

            <!-- Desglose prima por semana (sábado → viernes) -->
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="pa-3 grey lighten-4">
                <div class="text-subtitle-2 font-weight-medium mb-1">
                  Desglose de prima por semana
                </div>
                <div class="caption mb-3 grey--text text--darken-1">
                  Semana operativa: sábado a viernes. La nómina se acepta el viernes de esa semana.
                </div>
                <v-simple-table dense v-if="desglosePrimaSemanal(item).length">
                  <thead>
                    <tr>
                      <th>Semana</th>
                      <th>Periodo (sáb – vie)</th>
                      <th>Días de vacaciones</th>
                      <th>Prima a pagar</th>
                      <th>Aparece en nómina (viernes)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(sem, idx) in desglosePrimaSemanal(item)" :key="item.idvacaciones + '-sem-' + idx">
                      <td>Semana {{ idx + 1 }}</td>
                      <td>{{ sem.fecha_inicio }} → {{ sem.fecha_fin }}</td>
                      <td>{{ sem.dias }}</td>
                      <td>{{ formatMoney(sem.prima) }}</td>
                      <td>
                        <v-chip x-small color="blue" dark>{{ sem.fecha_nomina }}</v-chip>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="2" class="font-weight-bold">Total</td>
                      <td class="font-weight-bold">{{ sumaDiasDesglose(item) }}</td>
                      <td class="font-weight-bold">{{ formatMoney(sumaPrimaDesglose(item)) }}</td>
                      <td></td>
                    </tr>
                  </tfoot>
                </v-simple-table>
                <div v-else class="caption">
                  Sin fechas válidas para calcular el desglose.
                </div>
              </td>
            </template>

          </v-data-table>
        </v-card>
      </v-col>
    </v-row>


    <!-- ================= DIALOG EDITAR/AGREGAR ================= -->
    <v-dialog v-model="dialog" max-width="400px">
      <v-card>

        <v-card-title>
          {{ editedIndex === -1 ? 'Agregar Vacaciones' : 'Editar Vacaciones' }}
        </v-card-title>

        <v-card-text>

          <v-text-field
            v-model="editedItem.vacaciones"
            label="Vacaciones"
            filled dense
          />

          <v-autocomplete
            filled
            dense
            :clearable="puedeElegirOtroTrabajador"
            v-model="editedItem.idtrabajador"
            :items="trabajadores"
            label="Selecciona un trabajador"
            prepend-inner-icon="mdi-account"
            single-line
            item-text="nombre_completo"
            item-value="id_usuario"
            :disabled="!puedeElegirOtroTrabajador"
          />

          <v-text-field
            v-model="editedItem.fecha_inicio"
            label="Fecha Inicio"
            type="date"
            filled dense
          />

          <v-text-field
            v-model="editedItem.fecha_fin"
            label="Fecha Fin"
            type="date"
            filled dense
          />

          <v-text-field
            v-model="editedItem.dias_vacaciones"
            label="Días vacaciones"
            type="number"
            min="0"
            max="40"
            filled
            dense
            readonly
          />

        </v-card-text>

        <v-card-actions>
          <v-btn text @click="close">Cancelar</v-btn>
          <v-spacer/>
          <v-btn color="green" dark @click="save">Guardar</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>


    <!-- ================= DIALOG RESPUESTA JEFE/RH ================= -->
    <v-dialog v-model="dialogRespuesta" max-width="400px">
      <v-card>

        <v-card-title>
          Respuesta {{ tipoRespuesta.toUpperCase() }}
        </v-card-title>

        <v-card-text>

          <v-select
            v-model="respuestaTemp"
            :items="estatusItems"
            label="Estatus"
            filled dense
          />

          <v-textarea
            v-if="respuestaTemp==2"
            v-model="motivoTemp"
            label="Motivo rechazo"
            filled dense
          />

        </v-card-text>

        <v-card-actions>
          <v-btn text @click="dialogRespuesta=false">Cancelar</v-btn>
          <v-spacer/>
          <v-btn color="green" dark @click="guardarRespuesta">
            Guardar
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

  </v-container>
</template>


<script>
import { mapGetters } from 'vuex'
var XLSX = require('xlsx')

export default {

  computed : {
		...mapGetters('login',['getdatosUsuarioERPERP']),

    puedeSolicitarVacaciones () {
      const usuario = this.getdatosUsuarioERPERP
      if (!usuario || !usuario.fecha_alta ) return false


      // 1) Si el iderp está en la lista de excepciones, puede solicitar
      if (this.iderpUsuariosTieneVacaciones.includes(usuario.iderp)) {
        return true
      }

      // 2) Validar que haya pasado al menos un año desde fecha_alta
      const fechaAltaStr = usuario.fecha_alta // "2025-07-30 09:51:00"
      const [fechaSolo] = fechaAltaStr.split(' ') // "2025-07-30"
      const fechaAlta = new Date(fechaSolo)
      if (isNaN(fechaAlta)) return false

      const hoy = new Date()
      const unAnioDespues = new Date(fechaAlta)
      unAnioDespues.setFullYear(unAnioDespues.getFullYear() + 1)

      return hoy >= unAnioDespues
    },

    puedeElegirOtroTrabajador () {
      const iderp = this.getdatosUsuarioERPERP.iderp

      const esJefePermitido = this.iderpUsuariosPermitidosJefe.includes(iderp)
      const esRHPermitido   = this.iderpUsuariosPermitidosRH.includes(iderp)

      return esJefePermitido || esRHPermitido
    },

    vacacionesFiltradas () {
      let lista = this.vacaciones || []

      // Estatus: Aceptado = jefe Y RH aceptados; Pendiente/Rechazado = coincide en jefe o RH
      if (this.filtroEstatus !== null && this.filtroEstatus !== undefined && this.filtroEstatus !== '') {
        const estatus = Number(this.filtroEstatus)
        if (estatus === 1) {
          lista = lista.filter(item =>
            Number(item.respuesta_jefe) === 1 && Number(item.respuesta_rh) === 1
          )
        } else {
          lista = lista.filter(item =>
            Number(item.respuesta_jefe) === estatus ||
            Number(item.respuesta_rh) === estatus
          )
        }
      }

      // Persona (idtrabajador)
      if (this.filtroPersona != null && this.filtroPersona !== '') {
        const idPersona = Number(this.filtroPersona)
        lista = lista.filter(item => Number(item.idtrabajador) === idPersona)
      }

      // Rango de fechas: traslape con [filtroFechaInicio, filtroFechaFin]
      const desde = this.fechaSolo(this.filtroFechaInicio)
      const hasta = this.fechaSolo(this.filtroFechaFin)
      if (desde || hasta) {
        lista = lista.filter(item => {
          const ini = this.fechaSolo(item.fecha_inicio)
          const fin = this.fechaSolo(item.fecha_fin)
          if (!ini || !fin) return false
          if (desde && fin < desde) return false
          if (hasta && ini > hasta) return false
          return true
        })
      }

      return lista
    },

    personasFiltroItems () {
      const map = {}
      const lista = this.vacaciones || []
      for (let i = 0; i < lista.length; i++) {
        const item = lista[i]
        const id = item.idtrabajador
        if (id == null || id === '') continue
        if (!map[id]) {
          map[id] = {
            text: item.nombre_completo || ('ID ' + id),
            value: id,
          }
        }
      }
      return Object.keys(map)
        .map(k => map[k])
        .sort((a, b) => String(a.text).localeCompare(String(b.text), 'es'))
    },

	},

  data: () => ({

    dialog:false,
    dialogRespuesta:false,
    expanded: [],

    vacaciones:[],
    trabajadores: [],
    iderpUsuariosTieneVacaciones: [], // solo para pruebas, los iderp que esten aquí podrán solicitar vacaciones
    iderpUsuariosPermitidosJefe: [],
    iderpUsuariosPermitidosRH: [ 68 ],
    diasDisponibles: null,
    
    search:'',
    filtroEstatus: null,
    filtroPersona: null,
    filtroFechaInicio: '',
    filtroFechaFin: '',
    estatusFiltroItems: [
      { text: 'Todos',    value: null },
      { text: 'Pendiente', value: 0 },
      { text: 'Aceptado',  value: 1 },
      { text: 'Rechazado', value: 2 },
    ],

    headers:[
      { text: '', value: 'data-table-expand', sortable: false },
      { text:'ID', value:'idvacaciones' },
      { text:'Vacaciones', value:'vacaciones' },
      { text:'Empleado', value:'nombre_completo' },
      { text:'Fecha Inicio', value:'fecha_inicio' },
      { text:'Fecha Fin', value:'fecha_fin' },
      { text:'Días vacaciones', value:'dias_vacaciones' },
      { text:'Prima', value:'prima_vacaciones' },
      { text:'Jefe', value:'respuesta_jefe' },
      { text:'RH', value:'respuesta_rh' },
      { text:'Motivo Rechazo', value:'motivo_rechazo' },
      { text:'Actions', value:'actions', sortable:false }
    ],

    editedIndex:-1,

    editedItem:{
      idvacaciones:0,
      vacaciones:'',
      idtrabajador: 0,
      fecha_inicio:'',
      fecha_fin:'',
      dias_vacaciones:0
    },

    defaultItem:{
      idvacaciones:0,
      vacaciones:'',
      idtrabajador: 0,
      fecha_inicio:'',
      fecha_fin:'',
      dias_vacaciones:0
    },

    /* ===== respuesta rápida ===== */
    tipoRespuesta:'',
    itemRespuesta:null,
    respuestaTemp:0,
    motivoTemp:'',

    estatusItems:[
      { text:'Pendiente', value:0 },
      { text:'Aceptado', value:1 },
      { text:'Rechazado', value:2 }
    ]

  }),

  async created(){

    await this.obtenerDiasDisponibles()
    await this.getTrabajadores()
    this.initialize()
  },

  watch: {
    'editedItem.fecha_inicio': 'actualizarDiasVacaciones',
    'editedItem.fecha_fin'   : 'actualizarDiasVacaciones',
  },
  
  
  
  methods:{

    obtenerDiasDisponibles () {
      // getDiasDisponibles
      return this.$http
      .get(`vacaciones.get.dias.disponibles/${ this.getdatosUsuarioERPERP.iderp }`).then(response => {
        this.diasDisponibles = response.data.dias_disponibles || 0
        console.log( '///////////////' )
        console.log( this.diasDisponibles )
        })
        .catch(error => {
          this.validarError(error.response.data.message)
        })
        .finally(() => {
          this.cargar = false
        })
    },

    esJefe( id ) {

      this.cargar = true

      return this.$http
      .get(`vacaciones.es.jefe.directo/${id}`).then(response => {
        //console.log( this.getdatosUsuarioERPERP.idpuesto === response.data.id_puesto_jefe )
          return response.data.id_puesto_jefe
        })
        .catch(error => {
          this.validarError(error.response.data.message)
        })
        .finally(() => {
          this.cargar = false
        })
    },

    getTrabajadores () {
      this.cargar = true
      this.trabajadores = []

      console.log( this.getdatosUsuarioERPERP )

      return this.$http.get('vacaciones.get.trabajadores', {
        params: {
          id_puesto: this.getdatosUsuarioERPERP.idpuesto
        }
      })
        .then(response => {
          this.trabajadores = response.data.trabajadores
        })
        .catch(error => {
          this.validarError(error.response.data.message)
        })
        .finally(() => {
          this.cargar = false
        })
    },

    initialize(){
      console.log( this.getdatosUsuarioERPERP )
      this.$http.get('vacaciones.list')
        .then(r=> this.vacaciones=r.data)
    },

    save () {
    const esEdicion = this.editedIndex > -1

    const req = esEdicion
      ? this.$http.put('vacaciones.update/' + this.editedItem.idvacaciones, this.editedItem)
      : this.$http.post('vacaciones.add', this.editedItem)

    req.then(() => {
      this.$swal({
        icon: 'success',
        title: esEdicion ? 'Solicitud actualizada' : 'Solicitud registrada',
        text: esEdicion
          ? 'La solicitud de vacaciones se actualizó correctamente.'
          : 'La solicitud de vacaciones se agregó correctamente.',
        confirmButtonText: 'Aceptar'
      })

      this.close()
      this.initialize()
      this.obtenerDiasDisponibles()
    }).catch(error => {
      const mensaje =
      error.response.data.message ||
      'Ocurrió un error al guardar la solicitud de vacaciones.'

      this.$swal({
        icon: 'error',
        title: 'Error',
        text: mensaje,
        confirmButtonText: 'Aceptar'
      })
    })
    },

    abrirDialogSolicitud () {
      // Reiniciar formulario a valores por defecto (modo "agregar")
      this.editedIndex = -1
      this.editedItem  = { ...this.defaultItem }

      
      const iderpUsuario = this.getdatosUsuarioERPERP.iderp

      const esJefePermitido = this.iderpUsuariosPermitidosJefe.includes(iderpUsuario)
      const esRHPermitido   = this.iderpUsuariosPermitidosRH.includes(this.getdatosUsuarioERPERP.idpuesto)

      // Si NO es jefe permitido NI RH permitido, se autoselecciona él mismo
      if (!esJefePermitido && !esRHPermitido) {
        const trabajadorActual = this.trabajadores.find(
          t => t.id_usuario === iderpUsuario
        )

        if (trabajadorActual) {
          // El autocomplete usa item-value="id_usuario", y tu modelo es editedItem.idtrabajador
          this.editedItem.idtrabajador = trabajadorActual.id_usuario
        }
      }

      this.dialog = true
    },

    /* ================= RESPUESTAS ================= */

    async abrirRespuesta (item, tipo) {
    
    // 1) Consultar el id_puesto_jefe desde el back
    const idPuestoJefe = await this.esJefe(item.idtrabajador)

    if (idPuestoJefe === null) {
      // Hubo error en la petición, ya se mostró en validarError
      return
    }

    // 2) Calcular permiso
    const esUsuarioPermitidoJefe = this.getdatosUsuarioERPERP.idpuesto === idPuestoJefe || this.iderpUsuariosPermitidosJefe.includes(this.getdatosUsuarioERPERP.iderp)
    const esUsuarioPermitidoRH   = this.iderpUsuariosPermitidosRH.includes(this.getdatosUsuarioERPERP.idpuesto)

    let tienePermiso = false

    if (tipo === 'jefe') {
      // Puede responder como jefe si es el jefe directo o está en la lista de jefes permitidos
      tienePermiso = esUsuarioPermitidoJefe
    } else if (tipo === 'rh') {
      // Puede responder como RH si está en la lista de RH permitidos
      tienePermiso = esUsuarioPermitidoRH
    }

    // 3) Si no tiene permisos, mostrar mensaje y salir
    if (!tienePermiso) {
        this.$swal({
        icon: 'error',
        title: 'Sin permisos',
        text: 'No tiene permisos para realizar esta acción',
        confirmButtonText: 'Aceptar'
      })
      
      return
    }

    // 4) Validación extra para RH (que el jefe ya haya respondido)
    if (tipo === 'rh' && item.respuesta_jefe === 0) {
      this.$swal({
        icon: 'warning',
        title: 'Sin respuesta del jefe',
        text: 'El jefe directo aún no ha respondido la solicitud',
        confirmButtonText: 'Aceptar'
      })
    }

    // 5) Si tiene permisos, abrir la modal
    this.itemRespuesta = item
    this.tipoRespuesta = tipo
    this.respuestaTemp = tipo === 'jefe' ? item.respuesta_jefe : item.respuesta_rh
    this.motivoTemp    = item.motivo_rechazo || ''
    this.dialogRespuesta = true
  },

    guardarRespuesta(){

      if(this.respuestaTemp==2 && !this.motivoTemp){
        return alert('Debes escribir el motivo')
      }

      const payload={...this.itemRespuesta}

      if(this.tipoRespuesta==='jefe'){
        payload.respuesta_jefe=this.respuestaTemp
      }else{
        payload.respuesta_rh=this.respuestaTemp
      }

      payload.motivo_rechazo=this.motivoTemp

      this.$http.put('vacaciones.update/'+payload.idvacaciones,payload)
        .then(()=>{
          this.dialogRespuesta=false
          this.initialize()
        })
    },


    /* ================= UI ================= */

    editItem(item){
      this.editedIndex=this.vacaciones.indexOf(item)
      this.editedItem={...item}
      this.dialog=true
    },

     deleteItem (item) {
    this.$swal({
      title: '¿Eliminar solicitud?',
      text: 'Esta acción no se puede deshacer.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.$http
          .put('vacaciones.eliminar/' + item.idvacaciones)
          .then(() => {
            this.$swal({
              icon: 'success',
              title: 'Eliminada',
              text: 'La solicitud de vacaciones fue eliminada correctamente.',
              confirmButtonText: 'Aceptar'
            })
            this.initialize()
            this.obtenerDiasDisponibles()
          })
          .catch(error => {
            this.validarError(error.response.data.message)
          })
      }
    })
  },

    close(){
      this.dialog=false
      this.editedItem={...this.defaultItem}
      this.editedIndex=-1
    },


    /* helpers visuales */
    textoEstatus(v){
      return ['Pendiente','Aceptado','Rechazado'][v]
    },

    colorEstatus(v){
      return ['grey','green','red'][v]
    },

    formatMoney (valor) {
      const n = Number(valor)
      if (!Number.isFinite(n)) return '—'
      return n.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
    },

    /** YYYY-MM-DD desde string/Date sin desfase UTC */
    fechaSolo (valor) {
      if (valor == null || valor === '') return ''
      if (valor instanceof Date && !isNaN(valor)) {
        const y = valor.getFullYear()
        const m = String(valor.getMonth() + 1).padStart(2, '0')
        const d = String(valor.getDate()).padStart(2, '0')
        return y + '-' + m + '-' + d
      }
      const s = String(valor)
      const m = s.match(/^(\d{4}-\d{2}-\d{2})/)
      return m ? m[1] : ''
    },

    parseFechaLocal (valor) {
      const solo = this.fechaSolo(valor)
      if (!solo) return null
      const parts = solo.split('-').map(Number)
      const y = parts[0]
      const m = parts[1]
      const d = parts[2]
      const dt = new Date(y, m - 1, d)
      return isNaN(dt.getTime()) ? null : dt
    },

    formatFechaLocal (date) {
      if (!date || isNaN(date.getTime())) return ''
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return y + '-' + m + '-' + d
    },

    /** Sábado que inicia la semana operativa (sáb → vie) */
    sabadoInicioSemana (date) {
      const d = new Date(date.getFullYear(), date.getMonth(), date.getDate())
      const day = d.getDay() // 0=dom … 6=sáb
      const diasDesdeSabado = (day + 1) % 7
      d.setDate(d.getDate() - diasDesdeSabado)
      return d
    },

    /**
     * Parte la prima entre semanas sáb–vie.
     * Domingos no cuentan (igual que dias_vacaciones).
     * fecha_nomina = viernes de esa semana (día de aceptar nómina).
     */
    desglosePrimaSemanal (item) {
      if (!item) return []
      const inicio = this.parseFechaLocal(item.fecha_inicio)
      const fin = this.parseFechaLocal(item.fecha_fin)
      if (!inicio || !fin || fin < inicio) return []

      const primaTotal = Number(item.prima_vacaciones) || 0
      const diasDeclarados = Number(item.dias_vacaciones) || 0
      const semanasMap = {}

      const cursor = new Date(inicio.getFullYear(), inicio.getMonth(), inicio.getDate())
      while (cursor <= fin) {
        const esDomingo = cursor.getDay() === 0
        if (!esDomingo) {
          const sab = this.sabadoInicioSemana(cursor)
          const key = this.formatFechaLocal(sab)
          if (!semanasMap[key]) {
            const vie = new Date(sab.getFullYear(), sab.getMonth(), sab.getDate())
            vie.setDate(vie.getDate() + 6)
            semanasMap[key] = {
              fecha_inicio: key,
              fecha_fin: this.formatFechaLocal(vie),
              fecha_nomina: this.formatFechaLocal(vie),
              dias: 0,
            }
          }
          semanasMap[key].dias += 1
        }
        cursor.setDate(cursor.getDate() + 1)
      }

      const keys = Object.keys(semanasMap).sort()
      const diasContados = keys.reduce((s, k) => s + semanasMap[k].dias, 0)
      const baseDias = diasDeclarados > 0 ? diasDeclarados : diasContados
      const primaPorDia = baseDias > 0 ? primaTotal / baseDias : 0

      let primaAcum = 0
      const out = []
      for (let i = 0; i < keys.length; i++) {
        const sem = semanasMap[keys[i]]
        let prima = Math.round(primaPorDia * sem.dias * 100) / 100
        if (i === keys.length - 1) {
          prima = Math.round((primaTotal - primaAcum) * 100) / 100
        } else {
          primaAcum += prima
        }
        out.push({
          fecha_inicio: sem.fecha_inicio,
          fecha_fin: sem.fecha_fin,
          fecha_nomina: sem.fecha_nomina,
          dias: sem.dias,
          prima: prima,
        })
      }
      return out
    },

    sumaDiasDesglose (item) {
      return this.desglosePrimaSemanal(item).reduce((s, el) => s + el.dias, 0)
    },

    sumaPrimaDesglose (item) {
      return this.desglosePrimaSemanal(item).reduce((s, el) => s + (Number(el.prima) || 0), 0)
    },

    exportarVacacionesExcel () {
      const items = this.vacacionesFiltradas || []
      if (!items.length) {
        this.$swal({
          icon: 'info',
          title: 'Sin datos',
          text: 'No hay vacaciones para exportar con el filtro actual.',
          confirmButtonText: 'Aceptar',
        })
        return
      }

      const hojaVacaciones = items.map((item) => ({
        ID: item.idvacaciones,
        Vacaciones: item.vacaciones,
        Empleado: item.nombre_completo,
        'Fecha Inicio': this.fechaSolo(item.fecha_inicio),
        'Fecha Fin': this.fechaSolo(item.fecha_fin),
        'Días vacaciones': item.dias_vacaciones,
        Prima: Number(item.prima_vacaciones) || 0,
        Jefe: this.textoEstatus(item.respuesta_jefe),
        RH: this.textoEstatus(item.respuesta_rh),
        'Motivo Rechazo': item.motivo_rechazo || '',
      }))

      const hojaDesglose = []
      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        const semanas = this.desglosePrimaSemanal(item)
        for (let j = 0; j < semanas.length; j++) {
          const sem = semanas[j]
          hojaDesglose.push({
            ID: item.idvacaciones,
            Empleado: item.nombre_completo,
            Vacaciones: item.vacaciones,
            Semana: j + 1,
            'Inicio semana (sáb)': sem.fecha_inicio,
            'Fin semana (vie)': sem.fecha_fin,
            'Días en semana': sem.dias,
            'Prima semana': sem.prima,
            'Nómina (viernes)': sem.fecha_nomina,
            'Jefe': this.textoEstatus(item.respuesta_jefe),
            'RH': this.textoEstatus(item.respuesta_rh),
          })
        }
      }

      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(hojaVacaciones), 'Vacaciones')
      if (hojaDesglose.length) {
        XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(hojaDesglose), 'Desglose prima')
      }
      XLSX.writeFile(workbook, 'Vacaciones_empleados.xls')
    },

    actualizarDiasVacaciones () {
      const inicio = this.editedItem.fecha_inicio
      const fin    = this.editedItem.fecha_fin

      if (!inicio || !fin) {
        this.editedItem.dias_vacaciones = 0
        return
      }

      // Parsear como fecha local, no como UTC
      const [y1, m1, d1] = inicio.split('-').map(Number)
      const [y2, m2, d2] = fin.split('-').map(Number)

      const fechaInicio = new Date(y1, m1 - 1, d1)
      const fechaFin    = new Date(y2, m2 - 1, d2)

      if (isNaN(fechaInicio) || isNaN(fechaFin) || fechaFin < fechaInicio) {
        this.editedItem.dias_vacaciones = 0
        return
      }

      let dias = 0
      const cursor = new Date(fechaInicio)

      while (cursor <= fechaFin) {
        const esDomingo = cursor.getDay() === 0 // 0 = domingo
        if (!esDomingo) {
          dias++
        }
        cursor.setDate(cursor.getDate() + 1)
      }

      this.editedItem.dias_vacaciones = dias
    },

    puedeEditarItem (item) {
      const iderp = this.getdatosUsuarioERPERP.iderp

      // Solo se puede editar si ambos siguen pendientes
      const siguePendiente =
        item.respuesta_jefe === 0 &&
        item.respuesta_rh   === 0

      if (!siguePendiente) return false

      const esJefeORH =
        this.iderpUsuariosPermitidosJefe.includes(iderp) ||
        this.iderpUsuariosPermitidosRH.includes(this.getdatosUsuarioERPERP.idpuesto)

      const esSuPropiaSolicitud = item.idtrabajador === iderp

      return esJefeORH || esSuPropiaSolicitud
    },

    puedeEliminarItem (item) {
      const iderp = this.getdatosUsuarioERPERP.iderp
      if (!iderp) return false

      // Solo se puede eliminar si ambos siguen pendientes
      const siguePendiente =
        item.respuesta_jefe === 0 &&
        item.respuesta_rh === 0

      if (!siguePendiente) return false

      // Puede eliminar si es RH o Jefe permitido
      const esJefePermitido = this.iderpUsuariosPermitidosJefe.includes(iderp)
      const esRHPermitido   = this.iderpUsuariosPermitidosRH.includes(iderp)

      // O si es el creador de la solicitud
      const esSuPropiaSolicitud = item.idtrabajador === iderp || item.id_usuario === iderp

      return esJefePermitido || esRHPermitido || esSuPropiaSolicitud
    },

  }
}
</script>


<style scoped>
.pointer{
  cursor:pointer;
}
</style>
